export var defaultTheme = {
    accent: '#0096ff',
    background: '#ffffff',
    color: '#000000',
    inputBg: '#f3f4f8',
    inputColor: '#000000',
    inputError: '#e3005e',
    shadow: '0 5px 10px rgba(0, 0, 0, 0.04)',
    radius: 4,
    spacing: 8,
    fontSize: '13px',
};
